var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mds-layout-grid',[_c('title-section'),(!_vm.$route.params.id)?_c('search-company'):_vm._e(),_c('form-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }